import { Box, Button, Typography, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';

interface ExpertCompletionStepProps {
    onNext: () => void;
}

const ExpertCompletionStep: React.FC<ExpertCompletionStepProps> = ({ onNext }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    
    const handleNext = async () => {
        if (isLoading) return;
        setIsLoading(true);
        await onNext();
    };

    return (
        <>
        <Typography
        variant="h4"
        sx={{
            mb: 2,
            fontWeight: 600,
            textAlign: 'center',
        }}
    >
        {t('onboarding.expert.title')}
    </Typography>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                textAlign: 'center',
                py: 4,
                minHeight: '400px',
            }}
        >
 
            
            <Typography
                variant="body1"
                sx={{
                    mb: 4,
                    maxWidth: '600px',
                    lineHeight: 1.6,
                    fontSize: '1.1rem',
                    color: 'text.secondary',
                }}
            >
                {t('onboarding.expert.completionDescription')}
            </Typography>

            <Button
                variant="contained"
                size="large"
                onClick={handleNext}
                disabled={isLoading}
                sx={{
                    mt: 2,
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    borderRadius: 2,
                    opacity: isLoading ? 0.7 : 1,
                    pointerEvents: isLoading ? 'none' : 'auto',
                }}
                startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
            >
                {t('onboarding.expert.button')}
            </Button>
        </Box>
        </>
    );
};

export default ExpertCompletionStep;